module.exports = __webpack_public_path__ + "featpic.77de54db05.webp";